<template>
    <div class="container-fluid">
        <route-header>
            <h3>{{ $t('labels.nav.all_bookings') }}</h3>
            <div class="d-flex">
                <date-field class="mb-0" :cal="'right'" v-model="from" :disabledDates="{}"></date-field>
                <select-field v-if="auth.can['edit_users']" :name="'user'" v-model="user" class="ml-3 mb-0">
                    <option value="0">{{ $t('labels.all_workers')}}</option>
                    <optgroup :label="$t('labels.workers')">
                        <option v-for="user in users" :key="'user' + user.id" :value="user.id">{{ user.name }}</option>
                    </optgroup>
                </select-field>
            </div>
        </route-header>
      <div class="row">
        <div class="col">
          <nav-secondary-bookings></nav-secondary-bookings>
        </div>
      </div>
      <div class="row">
            <div class="col-12">
                <bookings />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { DateTime } from 'luxon'
export default {
  name: 'AllBookings',
  data () {
    return {
      user: null,
      from: DateTime.local().toISODate()
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      users: state => state.usersStore,
      resourceState: state => state.allBookingsState
    })
  },
  mounted () {
    if (this.resourceState.dateFrom) this.from = this.resourceState.dateFrom
    if (this.$route.query.user && this.auth.can.edit_users) this.user = this.$route.query.user
    else if (!this.auth.can.edit_users) this.user = this.auth.id
    else this.user = this.resourceState.user
    if (this.auth.can.edit_users) {
      this.$store.dispatch('index', { collection: 'Users' })
    }
  },
  watch: {
    from: function (val) {
      this.$store.commit('pushState', { view: 'allBookings', key: 'dateFrom', data: val })
    },
    user: function (val) {
      this.$store.commit('pushState', { view: 'allBookings', key: 'user', data: val })
    }
  }
}
</script>
